import React from "react";
import {
  makeStyles,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { i18n } from "../../../translate/i18n";
import InfoTip from "./InfoTip";

const useStyles = makeStyles((theme) => ({
  section: { padding: theme.spacing(2), marginTop: theme.spacing(2) },
  title: { marginBottom: theme.spacing(1.5), fontWeight: 600 },
  note: {
    marginTop: theme.spacing(1),
    fontSize: 12,
    color: "#888",
    fontStyle: "italic",
  },
}));

const CANAL_LABEL = {
  convencional: "aiAssistantStats.canalVenta.convencional",
  plan_ahorro: "aiAssistantStats.canalVenta.planAhorro",
  sin_dato: "aiAssistantStats.canalVenta.sinDato",
};

// PC-only. Desglose de canal de venta (P=Convencional / PA=Plan de ahorro).
// Solo se renderiza si hay ventas (ventaTotal>0). Nunca en TV.
const CanalVentaPanel = ({ stats }) => {
  const classes = useStyles();
  const bd = stats?.breakdowns;
  const rows = bd?.byCanalVenta;
  const ventaTotal = bd?.ventaTotal ?? 0;
  if (!rows || ventaTotal <= 0) return null;

  const pct = (n) =>
    ventaTotal > 0 ? `${Math.round((n / ventaTotal) * 1000) / 10}%` : "—";

  return (
    <Paper className={classes.section} elevation={2}>
      <Typography className={classes.title}>
        {i18n.t("aiAssistantStats.canalVenta.title")}
        <InfoTip tipKey="canalVenta" />
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{i18n.t("aiAssistantStats.canalVenta.filterLabel")}</TableCell>
            <TableCell align="right">
              {i18n.t("aiAssistantStats.funnel.enviados")}
            </TableCell>
            <TableCell align="right">%</TableCell>
            <TableCell align="right">
              {i18n.t("aiAssistantStats.funnel.respondieron")}
            </TableCell>
            <TableCell align="right">
              {i18n.t("aiAssistantStats.kpis.satisfechos")}
            </TableCell>
            <TableCell align="right">
              {i18n.t("aiAssistantStats.kpis.reclamos")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.canal}>
              <TableCell>
                {i18n.t(CANAL_LABEL[r.canal] || "aiAssistantStats.canalVenta.sinDato")}
              </TableCell>
              <TableCell align="right">{r.enviados ?? 0}</TableCell>
              <TableCell align="right">{pct(r.enviados ?? 0)}</TableCell>
              <TableCell align="right">{r.respondieron ?? 0}</TableCell>
              <TableCell align="right">{r.satisfechos ?? 0}</TableCell>
              <TableCell align="right">{r.reclamos ?? 0}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className={classes.note}>
        {i18n.t("aiAssistantStats.canalVenta.availabilityNote")}
      </div>
    </Paper>
  );
};

export default CanalVentaPanel;
